module.exports = __webpack_public_path__ + "media/2-7-1 Chinese New Year The Biggest Celebration on Earth .9a8ad573.mp4";